var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"md":"12"}},[_c('CCard',[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0px"},style:(("min-height: " + _vm.height)),attrs:{"src":"/proxy/sgucs/"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }